(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-scratch/assets/javascripts/components/top-bar/top-bar-menu/components/top-bar-menu-item.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-scratch/assets/javascripts/components/top-bar/top-bar-menu/components/top-bar-menu-item.js');
"use strict";

setGlobal('svs.ticketgames.ticketScratch.components.topBar.topBarMenu.TopBarMenuItem', _ref => {
  let {
    ariaLabel,
    handleOnClick,
    className,
    children,
    tabbable = true
  } = _ref;
  return React.createElement("a", {
    "aria-label": ariaLabel,
    className: className,
    href: "",
    onClick: e => {
      e.preventDefault();
      _.isFunction(handleOnClick) && handleOnClick();
    },
    tabIndex: tabbable ? '0' : '-1'
  }, children);
});

 })(window);